(() => {
  if (window.topKippahInquiriesReady) return;
  window.topKippahInquiriesReady = true;
  const context = document.getElementById('tk-inquiry-context');
  const product = context?.dataset.productTitle || '';
  const productUrl = context?.dataset.productUrl || '';
  const whatsappCopy = JSON.parse(document.getElementById('tk-whatsapp-copy')?.textContent || '{}');
  const params = new URLSearchParams(window.location.search);
  const requestedProduct = params.get('product')?.slice(0, 240) || '';
  const safeProductUrl = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin && /^\/(?:fr\/)?products\/[^/]+$/.test(url.pathname)
        ? url.origin + url.pathname : '';
    } catch { return ''; }
  };
  const requestedUrl = safeProductUrl(params.get('product_url'));
  const prepareLinks = () => {
    document.querySelectorAll('a[href]').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      if (product && url.origin === window.location.origin && /\/pages\/request-a-quote$/.test(url.pathname)) {
        url.searchParams.set('product', product);
        url.searchParams.set('product_url', productUrl);
        link.href = url.toString();
      }
      if (url.hostname === 'wa.me' && url.pathname === '/8615914047809' && !url.searchParams.has('text')) {
        const title = product || requestedProduct;
        const reference = productUrl || requestedUrl;
        const lines = [title ? whatsappCopy.product.replace('%{title}', title) : whatsappCopy.general];
        if (reference) lines.push(reference);
        lines.push(whatsappCopy.quantity, whatsappCopy.event, whatsappCopy.country, whatsappCopy.fabric);
        url.searchParams.set('text', lines.join('\n'));
        link.href = url.toString();
      }
    });
  };
  const prepareQuote = () => {
    const form = document.getElementById('TopKippahQuote');
    if (!form || form.dataset.contextReady) return;
    form.dataset.contextReady = 'true';
    if (requestedUrl && !form.querySelector('#tk-reference').value) form.querySelector('#tk-reference').value = requestedUrl;
    if (requestedProduct && !form.querySelector('#tk-notes').value) form.querySelector('#tk-notes').value = [requestedProduct, requestedUrl].filter(Boolean).join('\n');
  };
  const quoteStorageKey = 'tk_ads_quote_v1';
  const adsMeasurementAllowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return !window.Shopify?.designMode &&
      privacy?.analyticsProcessingAllowed?.() === true &&
      privacy?.marketingAllowed?.() === true;
  };
  const readQuoteAttempt = () => {
    try { return JSON.parse(window.sessionStorage.getItem(quoteStorageKey) || 'null'); }
    catch { return null; }
  };
  const writeQuoteAttempt = (value) => {
    try {
      if (value) window.sessionStorage.setItem(quoteStorageKey, JSON.stringify(value));
      else window.sessionStorage.removeItem(quoteStorageKey);
      return true;
    } catch { return false; }
  };
  const rememberQuoteAttempt = (form) => {
    const type = form.querySelector('#tk-request-type');
    const quantity = Number(form.querySelector('#tk-quantity')?.value);
    const bulk = type?.value === 'Bulk order (50 or more kippahs)' &&
      Number.isInteger(quantity) && quantity >= 50;
    if (!bulk || !adsMeasurementAllowed()) {
      writeQuoteAttempt(null);
      return;
    }
    writeQuoteAttempt({
      id: 'tkq_' + (window.crypto?.randomUUID?.() ||
        Date.now().toString(36) + '_' + Math.random().toString(36).slice(2)),
      created: Date.now(),
      bulk: true,
      sent: false
    });
  };
  let conversionRetry;
  const reportQuoteConversion = (attempt = 0) => {
    if (!document.querySelector('#TopKippahQuote [data-quote-success]')) return;
    const pending = readQuoteAttempt();
    if (!pending || pending.sent || pending.bulk !== true ||
        typeof pending.id !== 'string' || !pending.id.startsWith('tkq_') ||
        !Number.isFinite(pending.created) || Date.now() < pending.created ||
        Date.now() - pending.created > 1800000) return;
    if (!adsMeasurementAllowed() || typeof window.gtag !== 'function') {
      if (attempt < 30) {
        window.clearTimeout(conversionRetry);
        conversionRetry = window.setTimeout(() => reportQuoteConversion(attempt + 1), 500);
      }
      return;
    }
    if (!writeQuoteAttempt({ ...pending, sent: true })) return;
    try {
      window.gtag('event', 'conversion', {
        send_to: 'AW-18535570617/jvk0CJzx16gdELm5uYZF',
        transaction_id: pending.id
      });
    } catch {
      writeQuoteAttempt(pending);
    }
  };
  const publish = (name, extra = {}) => {
    const shopify = window.Shopify;
    if (shopify?.designMode || !shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    if (!shopify?.analytics?.publish) return;
    try {
      const result = shopify.analytics.publish(`topkippah:${name}`, {
        page_path: window.location.pathname,
        product_id: context?.dataset.productId || '',
        product_handle: productUrl ? new URL(productUrl).pathname.split('/').pop() : '',
        collection_handle: context?.dataset.collectionHandle || '',
        ...extra
      });
      if (result?.catch) result.catch(() => {});
    } catch { /* An analytics error must never interrupt an inquiry. */ }
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    if (url.hostname === 'wa.me' && url.pathname === '/8615914047809') publish('whatsapp_click');
    else if (url.origin === window.location.origin && /\/pages\/request-a-quote$/.test(url.pathname)) publish('quote_open');
    else if (url.origin === window.location.origin && /\/products\/custom-kippah-sample$/.test(url.pathname)) publish('sample_open');
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.id === 'TopKippahQuote' && form.checkValidity()) {
      rememberQuoteAttempt(form);
      publish('quote_submit');
    }
  });
  const setup = () => {
    prepareLinks(); prepareQuote();
    if (document.querySelector('#TopKippahQuote .tk-error')) writeQuoteAttempt(null);
    reportQuoteConversion();
    const success = document.querySelector('#TopKippahQuote [data-quote-success]');
    if (success && !success.dataset.eventReported) {
      success.dataset.eventReported = 'true';
      publish('quote_success');
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('visitorConsentCollected', () => reportQuoteConversion());
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
      if (!error) reportQuoteConversion();
    });
  }
})();
